import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function GamepadIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.25 5H13.75C16.5114 5 18.75 7.23858 18.75 10V13.4375C18.75 14.9908 17.4908 16.25 15.9375 16.25C15.0284 16.25 14.1757 15.8103 13.6484 15.0698L12.5 13.4375H7.5L6.35156 15.0698C5.82427 15.8103 4.97163 16.25 4.0625 16.25C2.5092 16.25 1.25 14.9908 1.25 13.4375V10C1.25 7.23858 3.48858 5 6.25 5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 10H8.125M6.875 8.75V11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 10.9375C13.6428 10.9375 14.0625 10.5178 14.0625 10C14.0625 9.48223 13.6428 9.0625 13.125 9.0625C12.6072 9.0625 12.1875 9.48223 12.1875 10C12.1875 10.5178 12.6072 10.9375 13.125 10.9375Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  )
}
